import { coreApi } from "../client";
import { JOBMASTER, PAYROLL } from "../endpoints";


export const getJobMasterList = async (payload) => {
    const res = await coreApi.post(JOBMASTER.JOBMASTER_LIST, payload);
    return res.data;
};
export const saveJobTitle = async (payload) => {
    const res = await coreApi.post(PAYROLL.SAVE_JOB_TITLE, payload);
    return res.data;
};
export const deleteJobTitle = async (id) => {
    const res = await coreApi.post(`${JOBMASTER.DELETE_JOB_TITLE}?ID=${id}`);
    return res.data;
};